<template>
  <div class="work-time-list">
    <work-time v-for="item in items" :key="item.day" :item="item" />
  </div>
</template>

<script>
  import WorkTime from '../item';

  export default {
    components: {
      WorkTime
    },
    props: {
      items: {
        type: Array,
        default: () => []
      }
    }
  };
</script>
